import Vue from 'vue'
import Vuex from 'vuex'
import redditAPI from "./api/reddit";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        posts: [],
        user: null
    },
    getters: {
        user(state) {
            return state.user
        },
        allPosts(state) {
            return state.posts;
        },
        comments(state) {
            return state.posts.filter(p => p.kind === 't1');
        },
        submissions(state) {
            return state.posts.filter(p => p.kind === 't3');
        },
        subreddits(state) {

        }
    },
    actions: {
        clearHistory({commit}) {
            commit('clearHistory')
        },
        fetchPage({commit}, {username, after}) {
            return redditAPI.getHistory(username, after).then(data => {
                commit('addHistory', {data: data.children})
                return data;
            })
        },
        fetchUser({commit}, username) {
            return redditAPI.getUser(username).then(data => {
                commit('setUser', {user:data})
                return data;
            });
        }
    },
    mutations: {
        clearHistory(state) {
            this.state.posts = [];
            // this.state.user = null;
        },
        addHistory(state, {data}) {
            let posts = state.posts;
            posts = [...data, ...posts]
            this.state.posts = posts;
        },
        setUser(state, {user}) {
            this.state.user = {...user};
        }
    }
})
